import React from 'react';
import { Panel } from '../../panel/panels';

export interface TitledPanelProps {
    overflow?: string;
    style?: React.CSSProperties;
    title: string;
    subtitle?: string;
    action?: React.ReactNode;
    outlet: React.ReactNode;
    height?: string | number;
    width?: string | number;
}

export const TitledPanel: React.FC<TitledPanelProps> = ({
    overflow,
    style,
    title,
    subtitle,
    action,
    outlet,
    height,
    width,
}) => {
    const panelStyle: React.CSSProperties = {
        ...style,
        height: height ?? '100%',
        width: width ?? '100%',
    };
    if (overflow !== undefined) {
        panelStyle.overflow = overflow;
    }

    return (
        <Panel style={panelStyle}>
            <div
                className="panel-mobile"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '20px',
                    height: '100%',
                }}
            >
                <div className="panelbox-header">
                    <div className="panelbox">
                        <div className="paneltitle">{title}</div>
                    </div>

                    {action && (
                        <div
                            className="panelbox-action"
                            style={{ textAlign: 'right', paddingBottom: '10px' }}
                        >
                            {action}
                        </div>
                    )}
                </div>

                <div style={{ flex: 1, minHeight: 0 }}>{outlet}</div>
            </div>
        </Panel>
    );
};
